import React from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import {
  Label,
  Input,
  FormGroup,
  InputGroup,
  InputGroupButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import Hint from '@components/Hint/Hint';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../../config';
import presets from '../../../fixtures/subIdPresets';
import { FMessage } from '../../../hoc/IntlComponents';

const View = ({ onChange, subAccount, toggle, open, renderPresets }) => {
  return (
    <FormGroup className={cn('form-group-upper-label', 'subaccount')}>
      <Label for="subAccount">
        <Link to="/faq/tools/flows/subid/create">Sub Account</Link>
        <Hint id="flow-form-subs-label-hint" popoverClassName="flow-form-subs-label-hint">
          <FMessage id="flow.form.subs.label.hint" />
        </Hint>
      </Label>
      <InputGroup>
        <Input
          id="subAccount"
          type="text"
          name="subAccount"
          onChange={onChange}
          value={subAccount}
          placeholder="subid1:subid2:subid3:subid4:subid5"
          autoComplete="off"
        />
        <InputGroupButtonDropdown addonType="append" isOpen={open} toggle={toggle}>
          <DropdownToggle color="light">
            <SVG
              src={`${STATIC_PATH}/img/action-icons/magic.svg`}
              height="20"
              width="20"
              cacheRequests
            />
          </DropdownToggle>
          <DropdownMenu right>{renderPresets(presets)}</DropdownMenu>
        </InputGroupButtonDropdown>
      </InputGroup>
    </FormGroup>
  );
};

export default View;
